import '@Application/Bootstrap';
import autoload from '@123/druid/dist/Framework/Decorators/Autoload';

import component from '@123/druid/dist/Framework/Decorators/Component';
import View from '@123/druid/dist/Framework/View/View';
import NewsCarouselView from '@Module/Home/View/NewsCarouselView';

@autoload
@component
export default class HomeModuleView extends View {
    protected mounted(): void {
        this.getViewOrNull(NewsCarouselView);
    }
}
